import React from 'react'

import ApproveProjectMulti from './ApproveProjectMulti'

export default function ApproveDisbursementMulti() {
  return <ApproveProjectMulti />
}
